// LIBRARIES
import styled from "styled-components";

//MISC;

export const HomePageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  /* height: calc(100vh - 40px); */
  margin-top: 40px;
`;
